import { render, staticRenderFns } from "./DataProductBirth.vue?vue&type=template&id=37a06dd8"
import script from "./DataProductBirth.vue?vue&type=script&lang=js"
export * from "./DataProductBirth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports